import { TokenSession } from 'urbnTokenLib';
import { debug } from '@core/js/utils/logger';
import { COOKIE_NAME_AUTH_PAYLOAD, scopeTypes } from '../constants';
import Cookies from '../services/cookies';

import serviceUrls from '@core/js/utils/serviceUrls';
import { isWebview } from '@core/js/utils/cookieUtils';

/**
 * Does the A15 store have profile data?
 * @param  {Function}  getState Redux state function
 * @return {Boolean}          True, if the A15 store has profile data; false, otherwise.
 */
export function hasProfileData(state) {
    return !_.isUndefined(_.get(state, 'core.profile.profileId'));
}

/**
 * Tests if the user has a loyalty username
 * @returns True if username found
 */
export function hasUsername(state) {
    return !_.isUndefined(_.get(state, 'core.profile.loyaltyUserName'));
}

/**
 * Does the current token have the given scope
 * @param  {String|Array}  scope List of scopes
 * @return {Boolean}       True, if the token has the given scopes; false, otherwise.
 */
export function hasScope(scope) {
    try {
        const ts = TokenSession.fromCookie();

        return ts.hasScope(scope);
    } catch (err) {
        // no session exists
        return false;
    }
}

/**
 * Is the current token session expired?
 * @return {Boolean} True, if the token session is expired; false, otherwise.
 */
export function isExpired() {
    try {
        const ts = TokenSession.fromCookie();

        return ts.isExpired();
    } catch (err) {
        return true;
    }
}

/**
 * Is the current user a guest?
 * @return {Boolean} True, if the current user is a guest; false, otherwise.
 */
export function isGuest() {
    return hasScope(scopeTypes.GUEST);
}

export function isRegistered() {
    return hasScope(scopeTypes.REGISTERED);
}

/**
 * Is the current user logged in?
 * @return {Boolean} True, if the current user is logged in; false, otherwise.
 */
export function isLoggedIn() {
    return hasScope(scopeTypes.AUTHORIZED) && !isExpired();
}

/**
 * Does the current user need to login?
 * @param {Function} getState Redux state function
 * @return {Boolean} True, if the current user is logged in with data; false, otherwise.
 */
export function needsLogin(state) {
    return !isLoggedIn() || !hasProfileData(state);
}

/**
 * Redirect to myaccount dashboard on small screens when logged in
 * @param {Object} component a component
 */
export function redirectToDashboardOnSmallScreens(component) {
    const core = component.getState().core;
    const deviceCharacteristics = component.getDeviceCharacteristics();

    if (core.loggedIn && (deviceCharacteristics.is_smallish || deviceCharacteristics.is_medium) && !isWebview()) {
        debug('Signed in on small screen non webview. Redirect to account');
        window.location = serviceUrls.accountURL(core.contextPath);
    }
}

export function isEmployee(profile) {
    let authPayload = Cookies.getCookieByName(COOKIE_NAME_AUTH_PAYLOAD);
    authPayload = JSON.parse(decodeURIComponent(authPayload));
    const scope = _.get(authPayload, 'scope', scopeTypes.GUEST);
    const employeeId = _.get(profile, 'employee.employeeId', '');

    return !_.isEmpty(employeeId) && scope === scopeTypes.AUTHORIZED;
}
